import { setTheme } from '../theme';



setTheme(require('../../src/themes/dfa').dfa);
